<template>
  <div>
    <a-card :tab-list="tabList" :active-tab-key="currentTab" @tabChange="tabChange">
      <div v-if="currentTab == 'stock_in'">
        <stock-in-panel></stock-in-panel>
      </div>
      <div v-else-if="currentTab == 'stock_out'">
        <stock-out-panel></stock-out-panel>
      </div>
    </a-card>
  </div>
</template>

<script>
  export default {
    components: {
      StockInPanel: () => import('./StockInPanel'),
      StockOutPanel: () => import('./StockOutPanel'),
    },
    data() {
      return {
        tabList: [
          {
            key: 'stock_in',
            tab: this.$t('入库'),
          },
          {
            key: 'stock_out',
            tab: this.$t('出库'),
          },
        ],
        currentTab: undefined,
      }
    },
    methods: {
      initData() {
        let currentTab = this.$route.query.currentTab;
        if (currentTab) {
          this.currentTab = currentTab;
        } else {
          this.currentTab = this.tabList[0].key;
          this.$router.push({ query: { currentTab: this.currentTab } });
        }
      },
      tabChange(key) {
        this.currentTab = key;
        this.$router.push({ query: { currentTab: this.currentTab } });
      },
    },
    mounted() {
      this.initData();
    },
  }
</script>